import { render, staticRenderFns } from "./InvoiceDiscountView.vue?vue&type=template&id=4bb4ace3&"
import script from "./InvoiceDiscountView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDiscountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports